import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

// Returns the current calendar year. Because this is evaluated at render time,
// the footer copyright automatically rolls over as soon as the visitor's clock
// crosses midnight on January 1.
function currentCopyrightYear() {
    return new Date().getFullYear();
}

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-acre-footer text-acre-footerText mt-0"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-6">
                    <div className="font-serif-display text-4xl tracking-tight text-white">
                        Chesterton
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-acre-footerText/70 mt-2">
                        Attorneys at Law
                    </div>
                    <p className="mt-6 max-w-md text-sm leading-relaxed text-acre-footerText/80">
                        A modern law firm for landowners, family businesses, and the closely-held enterprises that grow up alongside them.
                    </p>

                    <div className="mt-8 space-y-3 text-sm">
                        <a
                            href="mailto:info@chesterton.law"
                            data-testid="footer-email"
                            className="flex items-center gap-3 hover:text-white transition-colors"
                        >
                            <Mail size={15} strokeWidth={1.5} /> info@chesterton.law
                        </a>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <div className="text-[11px] uppercase tracking-[0.25em] text-acre-footerText/70 mb-5">
                        Practice
                    </div>
                    <ul className="space-y-3 text-sm">
                        <li><Link data-testid="footer-link-estate" to="/estate-planning" className="hover:text-white transition-colors">Estate Planning</Link></li>
                        <li><Link data-testid="footer-link-elder" to="/elder-law" className="hover:text-white transition-colors">Elder Law</Link></li>
                        <li><Link data-testid="footer-link-realestate" to="/real-estate-law" className="hover:text-white transition-colors">Real Estate</Link></li>
                        <li><Link data-testid="footer-link-business" to="/business-law" className="hover:text-white transition-colors">Business Law</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <div className="text-[11px] uppercase tracking-[0.25em] text-acre-footerText/70 mb-5">
                        Firm
                    </div>
                    <ul className="space-y-3 text-sm">
                        <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white transition-colors">About</Link></li>
                        <li><Link data-testid="footer-link-values" to="/values" className="hover:text-white transition-colors">Our Values</Link></li>
                        <li><Link data-testid="footer-link-people" to="/people" className="hover:text-white transition-colors">People</Link></li>
                        <li><Link data-testid="footer-link-practice" to="/practice-areas" className="hover:text-white transition-colors">Practice Areas</Link></li>
                        <li><Link data-testid="footer-link-blog" to="/blog" className="hover:text-white transition-colors">Insights</Link></li>
                        <li><Link data-testid="footer-link-news" to="/news" className="hover:text-white transition-colors">News</Link></li>
                        <li><Link data-testid="footer-link-careers" to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
                        <li><Link data-testid="footer-link-legal-links" to="/legal-links" className="hover:text-white transition-colors">Legal Links</Link></li>
                        <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-acre-footerText/70">
                    <div data-testid="footer-copyright" className="max-w-lg leading-relaxed">
                        © {currentCopyrightYear()}. All rights reserved. Chesterton is a registered service mark of Shelton Law PLLC, a Tennessee law firm.
                    </div>
                    <div className="max-w-2xl text-[11px] leading-relaxed">
                        Attorney advertising. The information on this site is provided for general informational purposes and does not constitute legal advice or form an attorney–client relationship.
                    </div>
                </div>
            </div>
        </footer>
    );
}
